import {StepperSelectionEvent}                                from '@angular/cdk/stepper';
import {Component, Inject, OnInit, ViewChild}                 from '@angular/core';
import {FormBuilder, FormGroup, Validators}                   from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef}                        from '@angular/material/dialog';
import {MatPaginator}                                         from '@angular/material/paginator';
import {MatSnackBar}                                          from '@angular/material/snack-bar';
import {MatTableDataSource}                                                        from '@angular/material/table';
import {FailedProjectedPrice, Price, Product, ProductManufacturer, ProjectedPrice} from '@src/app/admin/products/models/product.model';
import {ApiService}                                                                from '@src/app/shared/services/api.service';
import {FileService}                                          from '@src/app/shared/services/file.service';
import moment                                                 from 'moment';

@Component({
    standalone: false,
    selector: 'app-price-upload-modal',
    templateUrl: './price-upload-modal.component.html',
    styleUrls: ['./price-upload-modal.component.scss']
})
export class PriceUploadModalComponent implements OnInit
{
    @ViewChild(MatPaginator)
    public paginator!: MatPaginator;

    public pageSize: number = 10;

    public priceImportForm: FormGroup;

    public stepIndex: number = 0;

    public minimumEffectiveFrom: Date = new Date();

    // TODO: Better name
    public submitted: boolean = false;

    // TODO: Better name
    public loading: boolean = false;

    public priceImportId: string = null;

    public projectedPriceChanges: MatTableDataSource<ProjectedPrice> = new MatTableDataSource([]);

    public successfulRowCount: number = 0;

    public failedRowCount: number = 0;

    public failedPriceChanges: FailedProjectedPrice[];

    public constructor(
        @Inject(MAT_DIALOG_DATA)
        public data: { productManufacturer: ProductManufacturer },
        public priceUploadModal: MatDialogRef<PriceUploadModalComponent>,
        public snackBar: MatSnackBar,
        private fileService: FileService,
        private apiService: ApiService,
        private formBuilder: FormBuilder,
    )
    {
    }

    public ngOnInit(): void
    {
        this.priceImportForm = this.formBuilder.group({
            manufacturer_product_id: [this.data.productManufacturer.id, Validators.required],
            effective_from: [null, Validators.required],
        });
    }

    public uploadFile(): void
    {
        if (this.priceImportForm.valid) {
            this.loading = true;

            const formData = new FormData();

            this.fileService.append('price_file', formData);

            formData.append('manufacturer_product_id', this.priceImportForm.get('manufacturer_product_id')?.value);
            formData.append('effective_from', moment(this.priceImportForm.get('effective_from')?.value).format('YYYY-MM-DD'));

            this.apiService.post('prices-import/upload', formData).subscribe({
                next: (response) => {
                    this.projectedPriceChanges.data = response.data.projected_changes;
                    this.projectedPriceChanges.paginator = this.paginator;

                    this.priceImportId = response.data.id;

                    this.submitted = true;
                    this.stepIndex = this.stepIndex + 1;
                },
                error: (response) => {
                    this.priceUploadModal.close(false);
                    this.snackBar.open(response.error?.message ?? 'We were unable to process your file, please contact our support team.', 'Ok.');

                    this.apiService.handleError(response);
                },
                complete: () => this.loading = false
            });
        }
    }

    public processPrices(): void
    {
        this.apiService.get(`prices-import/${this.priceImportId}/process`).subscribe({
            next: (response) => {

                this.successfulRowCount = response.data.successful_row_count;
                this.failedRowCount = response.data.failed_row_count;
                this.failedPriceChanges = response.data.failed_rows;

                this.stepIndex = this.stepIndex + 1;
            },
            error: (error) => this.apiService.handleError(error),
            complete: () => this.loading = false
        });
    }

    public onTabChanged(event: StepperSelectionEvent): void
    {
        if (event.selectedIndex === 2) {
        }

        if (event.selectedIndex === 3) {
        }
    }
}
